module.exports = __webpack_public_path__ + "img/5.04.thmb.0105c86b.jpg";